import Container from '@/components/Container';
import SubContainer from '@/components/Container/SubContainer';

const Loading = () => {
  return (
    <Container className="h-full">
      <SubContainer className="flex items-center justify-center">
        <div className="my-8 h-[50vh] w-[430px] animate-pulse rounded-2xl bg-gray-300"></div>
      </SubContainer>
    </Container>
  );
};

export default Loading;
